<template>
  <div style="display: flex;">
    <span v-if="showLabel" style="margin-right:20px;font-size:14px;color:#606266;width:60px">
      {{ label }}
    </span>
    <el-upload class="upload-demo" drag :multiple="showFileList ? multipleFile : false" :disabled="!editMode" ref="upload" :show-file-list="false" :action="uploadAction" :accept="uploadFileType" :headers="uploadHeaders" :before-upload="fileValidate" :on-success="
        (response, file, fileList) => onUploadSuccess(response, file, fileList)
      ">
      <div v-show="showFileList || (!showFileList && !imgUrl)">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </div>
      <div v-show="!showFileList && imgUrl" class="image">
        <!-- 单图 -->
        <img class="avatar" :src="imgUrl" alt="" height="120px" />
        <span class="upload-action" v-if="!showFileList">
          <div class="upload-action-group" @click.stop="goupClick">
            <span class="upload-btn" v-preventReClick @click.stop="privewImg()">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span v-if="editMode" class="upload-btn" v-preventReClick @click.stop="RemoveFile()">
              <i class="el-icon-delete"></i>
            </span>
          </div>
        </span>
      </div>
    </el-upload>
    <div class="fileList" v-if="showFileList">
      <!-- 多图 -->
      <label v-preventReClick @click="fileListOpen = !fileListOpen">
        已上传的附件
        <i :class="fileListOpen ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
      </label>
      <ul v-if="btnShowType == 'always'" class="fileListUl_always" :class="fileListOpen ? '' : 'close'">
        <li class="fileItem" v-for="(item, index) in fileInfos" :key="index">
          <span class="fileName">{{ item.name }}</span>
          <div class="btn_group" :class="!editMode ? 'canedit' : ''">
            <span v-preventReClick @click="privewImg(item)">
              点击查看
            </span>
            <span v-preventReClick @click="downloadImg(item)">
              下载
            </span>
            <span v-show="editMode" v-preventReClick @click="RemoveFile(item)">
              删除
            </span>
          </div>
        </li>
      </ul>
      <ul v-else class="fileListUl_cover" :class="fileListOpen ? '' : 'close'" :style="'height:' + (fileInfos ? fileInfos.length : 0) * 23 + 'px'">
        <li class="fileItem" v-for="(item, index) in fileInfos" :key="index">
          <i class="el-icon-document"></i>
          <span>{{ item.name }}</span>
          <div class="btn_group" :class="!editMode ? 'canedit' : ''">
            <i class="el-icon-zoom-in" v-preventReClick @click="privewImg(item)"></i>
            <i class="el-icon-download" v-preventReClick @click="downloadImg(item)"></i>
            <i v-show="editMode" class="el-icon-delete" v-preventReClick @click="RemoveFile(item)"></i>
          </div>
        </li>
      </ul>
    </div>
    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import ElImageViewer from "@/components/elImageViewer";
export default {
  mixins: [GetDataMixin],
  components: {
    ElImageViewer,
  },
  /** 定义属性 */
  data () {
    return {
      fileListOpen: true,
      dialogVisible: false,
      dialogImageUrl: "",
      fileName: "",
      fileId: 0,
      fileInfos: this.fileList,
      imgUrl: "", //图片
    };
  },
  props: {
    label: {
      type: String,
      default () {
        return "上传附件";
      },
    },
    editMode: {
      type: Boolean,
      default () {
        return true;
      },
    },
    fileList: {
      type: Array,
      default () {
        return [];
      },
    },
    showLabel: {
      type: Boolean,
      default () {
        return true;
      },
    },
    showFileList: {
      type: Boolean,
      default () {
        return true;
      },
    },
    multipleFile: {
      type: Boolean,
      default () {
        return true;
      },
    },
    limit: {
      type: Number,
      default () {
        return 5;
      },
    },
    btnShowType: {
      type: String,
      default () {
        return "cover";
      },
    },
    maxSize: {
      type: Number,
      default () {
        return 50;
      },
    },
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {
    fileList (val) {
      this.fileInfos = val;
    },
  },
  /** 方法集合 */
  methods: {
    privewImg (file) {
      // this.dialogImageUrl = file.path;
      // this.dialogVisible = true;
      if (!this.showFileList) {
        this.fileId = this.fileInfos[0].id;
        this.fileName = this.fileInfos[0].name;
      } else {
        this.fileId = file.id;
        this.fileName = file.name;
      }
      this.dialogVisible = true;
    },
    closeImageViewer () {
      this.dialogVisible = false;
    },
    // downloadImg (file) {
    //   // 下载图片
    //   FileDownLoad({ fileId: file.id })
    //     .then((res) => new Blob([res]))
    //     .then((data) => {
    //       const blobUrl = window.URL.createObjectURL(data);
    //       const a = document.createElement("a");
    //       a.style.display = "none";
    //       a.download = file.name;
    //       a.href = blobUrl;
    //       a.click();
    //     });
    // },
    getFile (file) {
      if (file && file.id) {

        this.$axios
          .get(`${this.downloadUrl}?fileId=${file.id}`, {
            responseType: 'arraybuffer'
          })
          // FileDownLoad({ fileId: file.id }) // this.fileId
          .then((res) => {
            return (
              "data:image/png;base64," +
              btoa(
                new Uint8Array(res.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              )
            );
          })
          .then((data) => {
            this.imgUrl = data;
          });
      }
    },
    RemoveFile (file) {
      if (this.showFileList) {
        var index = this.fileInfos.indexOf(file);
        if (index > -1) {
          this.fileInfos.splice(index, 1);
        }
      } else {
        this.fileInfos = [];
        this.imgUrl = "";
      }
    },
    fileValidate (file) {
      // if (file.size > 1024 * 1024 * 3) {
      //   this.$my_message(`图片大小超过3M,上传失败！`, "warning");
      //   return false;
      // }
      if (this.fileInfos.length == this.limit) {
        this.$my_message(
          `抱歉！当前上传附件总数已超过系统限制，请核实后再上传！`,
          "warning"
        );
        return false;
      }
      let size = 0;
      this.fileInfos.forEach((item) => {
        size += item.size;
      });
      if (size + file.size >= this.maxSize * 1024 * 1024) {
        this.$my_message(
          `抱歉！当前上传附件总大小已超过系统限制，请核实后再上传！`,
          "warning"
        );
        return false;
      }
    },
    onUploadSuccess (response, file, fileList) {
      response.returnData.forEach((item) => {
        if (this.showFileList) {
          this.fileInfos.push(item);
        } else {
          this.fileInfos = [item];
        }
      });
      if (!this.showFileList) {
        this.getFile(this.fileInfos[0]);
      }
      this.$emit("fileChange", this.fileInfos);
    },
    goupClick () { },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () { },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    if (!this.showFileList) {
      this.getFile(this.fileInfos[0]);
    }
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
.fileList {
  margin-left: 20px;
  label {
    cursor: pointer;
    font-size: 13px;
    color: #286ab4;
    .el-icon-caret-top {
      transition: 1s;
    }
    .el-icon-caret-bottom {
      transition: 1s;
    }
  }
  .fileListUl_cover {
    transition: 0.3s;
    // height: 0px;
    overflow: hidden;
    padding: 0;
    font-size: 12px;
    .fileItem {
      padding: 2px 0;
      width: 150px;
      list-style-type: none;
      cursor: default;
      position: relative;
      .el-icon-document {
        float: left;
        line-height: 20px;
      }
      .el-icon-close {
        float: right;
        line-height: 20px;
        cursor: pointer;
      }
      span {
        display: -moz-inline-box; /* css注释：for ff2 */
        display: inline-block;
        width: 130px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .btn_group {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-color: #7a7b7d;
        height: 23px;
        color: white;
        font-size: 16px;
        border-radius: 3px;
        opacity: 0.8;
        transition: 0.5s;
        i {
          margin-left: 16%;
          text-align: center;
          cursor: pointer;
        }
      }
      .canedit {
        i {
          margin-left: 25%;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .fileItem:hover {
      background-color: #e5e9f8;
      color: #286ab4;
      .btn_group {
        display: block;
        transition: 0.5s;
      }
    }
  }
  .fileListUl_cover.close {
    transition: 0.5s;
    height: 0 !important;
    // height: 115px;
  }
  .fileListUl_always {
    font-size: 12px;
    background-color: white;
    height: 78px;
    padding: 5px;
    border-radius: 5px;
    width: 350px;
    overflow: hidden;
    overflow-y: auto;
    transition: 0.5s;
    margin-bottom: 0;
    &::-webkit-scrollbar {
      width: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(40, 106, 180, 0.5);
      border-radius: 10px;
    }
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    .fileItem {
      display: flex;
      padding: 2px 0;
      width: 350px;
      list-style-type: none;
      cursor: default;
      text-align: center;
      .fileName {
        line-height: 17px;
        transition: 0.4s;
        display: -moz-inline-box; /* css注释：for ff2 */
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        border-bottom: 1px transparent solid;
        color: #c8c9cc;
        flex: 1;
      }
      .btn_group {
        line-height: 17px;
        width: 140px;
        span {
          transition: 0.4s;
          margin: 0 5px;
          cursor: pointer;
          color: rgba(40, 106, 180, 0.2);
        }
      }
    }
    .fileItem:hover {
      .fileName {
        transition: 0.4s;
        color: rgba(40, 106, 180, 0.5);
        border-bottom: 1px rgba(40, 106, 180, 0.5) solid;
      }
      .btn_group {
        span {
          transition: 0.4s;
          color: #286ab4;
        }
      }
    }
  }
  .fileListUl_always.close {
    transition: 0.5s;
    height: 0 !important;
    padding: 0 5px;
    // height: 115px;
  }
}
/deep/.el-upload-dragger {
  width: 250px;
  height: 120px;
  background-color: #f2f2f2;
  .el-icon-upload {
    margin: 20px 0 0;
    color: #e3e4e6;
  }
  .el-upload__text {
    color: #909399;
  }
}
.upload-demo {
  position: relative;
  .image {
    .avatar {
      border: 1px solid #97c4e6;
      border-radius: 6px;
      box-sizing: border-box;
    }
    .upload-action {
      opacity: 0;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      width: 250px;
      height: 120px;
      left: 0;
      border-radius: 5px;
      .upload-action-group {
        width: 100%;
        height: 100%;
        justify-content: center;
        display: flex;
        align-items: center;
        .upload-btn {
          margin: 0 10px;
          color: white;
          font-size: 20px;
        }
      }
    }
  }
  .image:hover .upload-action {
    opacity: 1;
  }
}
</style>
